export default "__VITE_ASSET__7c0bfeb6__"